import { client } from "api";
import { CompletedChecklist, TimePeriod } from "models/UserStatistics";

export type GetCompletedChecklistsRequest = {
  userId: string;
  timePeriod: TimePeriod;
  onlyIncludeApprovedChecklists: boolean;
};

export type GetCompletedChecklistsResponse = CompletedChecklist[];

export const getCompletedChecklists = (
  request: GetCompletedChecklistsRequest
): Promise<CompletedChecklist[]> =>
  client
    .post<{
      userId: string;
      completedChecklists: CompletedChecklist[];
    }>(`/user/get-completed-checklists`, request)
    .then((res) => res.data.completedChecklists);
